import React from "react";
import { whyChoose, uniquePoints, stats } from "../mock";
import { Clock, ShieldCheck, Home, UserCheck, Wallet, Sparkles, Award, Star, CalendarCheck } from "lucide-react";

const icons = [Clock, ShieldCheck, Sparkles, Home, UserCheck, Award];

const WhyChoose = () => {
  return (
    <section id="why" className="py-14 md:py-20 scroll-mt-24">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-12">
        <div className="grid lg:grid-cols-2 gap-10 items-center">
          <div className="img-zoom-wrap relative rounded-3xl overflow-hidden shadow-xl">
            <img
              src="https://images.unsplash.com/photo-1761718210089-ba3bb5ccb54f?crop=entropy&cs=srgb&fm=jpg&q=85&w=800"
              alt="Why choose BeBlushify home salon"
              className="img-zoom w-full h-full max-h-[520px] object-cover"
            />
          </div>
          <div>
            <p className="text-primary font-semibold tracking-wide uppercase text-sm">Why Choose Us</p>
            <h2 className="font-display text-3xl md:text-4xl font-bold text-gray-900 mt-2">
              Why Choose BeBlushify Home Salon Services?
            </h2>
            <div className="mt-7 space-y-5">
              {whyChoose.slice(0, 4).map((w, i) => {
                const Icon = icons[i];
                return (
                  <div key={w.title} className="flex gap-4">
                    <div className="w-11 h-11 rounded-xl bg-secondary flex items-center justify-center text-primary shrink-0">
                      <Icon className="w-5 h-5" />
                    </div>
                    <div>
                      <h3 className="font-semibold text-gray-900">{w.title}</h3>
                      <p className="text-sm text-gray-600 mt-1">{w.text}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        {/* stats band */}
        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-4">
          {[
            { icon: UserCheck, big: stats.professionals, small: "Beauty Professionals" },
            { icon: Star, big: stats.rating, small: `${stats.ratingsCount} ratings` },
            { icon: CalendarCheck, big: stats.bookings, small: "Bookings in 3 months" },
            { icon: Wallet, big: "₹499", small: "Min. booking value" },
          ].map((s) => (
            <div key={s.small} className="bg-secondary/60 rounded-2xl p-6 text-center">
              <s.icon className="w-7 h-7 text-primary mx-auto" />
              <div className="font-display text-2xl md:text-3xl font-extrabold text-gray-900 mt-2">{s.big}</div>
              <div className="text-xs md:text-sm text-gray-600 mt-1">{s.small}</div>
            </div>
          ))}
        </div>

        {/* unique points */}
        <div className="mt-16">
          <h2 className="font-display text-2xl md:text-3xl font-bold text-gray-900 text-center max-w-3xl mx-auto">
            How is BeBlushify Salon at Home better than regular salons?
          </h2>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 mt-8">
            {uniquePoints.map((p, i) => (
              <div key={p.title} className="svc-card bg-white rounded-2xl p-6 ring-1 ring-black/5 shadow-sm hover:shadow-lg">
                <div className="w-10 h-10 rounded-full bg-primary/10 text-primary flex items-center justify-center font-bold">{i + 1}</div>
                <h3 className="font-semibold text-gray-900 mt-4">{p.title}</h3>
                <p className="text-sm text-gray-600 mt-2">{p.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChoose;
